import { courseService } from '@/api'
import { AsyncRequest } from '@/utils/request'
const state = {
  title: '老师介绍',
  courseInfo: {
    // avtarUrl: 'https://img-cdn1.ylyk.com/image/1652686476565_m1652190766464_s62460.jpg?imageMogr2/auto-orient/thumbnail/!160x160r/strip/gravity/Center/crop/160x160/size-limit/64k!',
    // brief: 'b2',
    // createTime: '2022-05-13T11:22:33.000+0000',
    // teacherId: 1,
    // teacherName: 't1'
  }
}

const getters = {
  courseInfo: state => state.courseInfo,
  title: state => state.title
}

const mutations = {
  upInfo: (state, info) => {
    state.courseInfo = info
  }
}

const actions = {
  // 获取列表
  getInfo({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => courseService.courseTeamTeacher(data),
      resolve: (res) => {
        commit('upInfo', res)
      },
      reject: (error) => {
        console.log('error-setAccount', error)
        // toast(error)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

